import React from 'react';
import {Grid, GridProps} from "@mui/material";

type CollapsableCardItemContainerProps = GridProps

/**
 * MUI Grid component styled in the SecurSpace way. Used as a container for Label-Value pairs inside the CollapsableCard suite of components
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardItemContainer = ({ children, ...rest}: CollapsableCardItemContainerProps) => {
  return <Grid item xs={6} sm={4} md={2} {...rest}>
    { children }
  </Grid>
}

export { CollapsableCardItemContainer };
